/*
 * Desktop - PLP - Retail Price Comparison  --  variant: Retail Price Next to Main Price
 * Moonshot experiment id: 70047041   status in Moonshot on 2026-08-27: DEPLOYED   started: 2026-04-17
 * Audience: DESKTOP   Target: plp   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_plp_d_retail_price
 */
MGExp.run('plp_d_retail_price', { name: "Desktop - PLP - Retail Price Comparison / Retail Price Next to Main Price", platform: 'desktop', target: 'plp' }, function () {
  !(function () {
    let e = [],
      t = [];
    !(async function (i, n, r, a, l) {
      let o = {
        multi_target_selectors: e,
        page_identifier_selector: "body.template-collection-left-align",
        exclude_from_timeout: t,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(i, n, r, a, l, o);
    })(
      [".grid--uniform.grid--view-items", ".product-card"],
      ".msai-retail-price-moved",
      function (e, t) {
        const [i, n] = t;
        i.querySelectorAll(".product-card").forEach(function (e) {
          if (e.querySelector(".msai-multi-price-row")) return;
          const t = e.querySelector(".retail-price"),
            i = e.querySelector(
              "form.plp-d-form .text-xs.md\\:text-sm.text-gray-800",
            );
          if (!t || !i || !t.textContent.trim()) return;
          const n = document.createElement("div");
          n.className = "msai-multi-price-row msai-retail-price-moved";
          const r = i.cloneNode(!0);
          n.appendChild(r);
          const a = document.createElement("span");
          ((a.className = "msai-multi-retail-label"),
            (a.textContent = t.textContent.trim()),
            n.appendChild(a),
            i.insertAdjacentElement("beforebegin", n),
            i.classList.add("msai-multi-original-price-hidden"));
          const l = t.closest(".flex.items-center.space-x-3");
          l && l.classList.add("msai-multi-retail-wrapper-hidden");
        });
      },
      "\n.msai-multi-price-row {\n    display: flex;\n    align-items: baseline;\n    gap: 20px;\n    margin-right: 8px;\n}\n.msai-multi-retail-label {\n    font-family: Raleway, sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    color: rgb(51, 51, 51);\n    line-height: 14px;\n    white-space: nowrap;\n}\n.msai-multi-original-price-hidden {\n    display: none !important;\n}\n.msai-multi-retail-wrapper-hidden {\n    display: none !important;\n}\n",
    );
  })();
});
